import { AppConfig } from '../../models/config/app-config.type';

export const domainIdFactory = (config: AppConfig): string => config.domainId;
